import { render, staticRenderFns } from "./CreateFigureModal.vue?vue&type=template&id=cb09a93a"
import script from "./CreateFigureModal.vue?vue&type=script&lang=js"
export * from "./CreateFigureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports